import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getUserInfo } from '../app/auth';
import { selectServiceAccess } from '../features/common/authSlice';

const useServiceAccess = () => {
  const permissions = useSelector(selectServiceAccess);
  const refreshAccess = useCallback(async (options = {}) => {
    await getUserInfo(options);
  }, []);

  return { ...permissions, refreshAccess };
};

export default useServiceAccess;
